// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import {CssBaseline} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';

// Components
import Header from '../nav/header';
import Content from '../nav/content';
import Footer from '../nav/footer';
import Root from '../nav/root';

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100vh',
  },
  list: {
    paddingTop: '0px',
  },
  toolbar: theme.mixins.toolbar,
}));

const config = {
  navAnchor: 'left',
  navVariant: 'persistent',
  navWidth: 0,
  collapsible: true,
  collapsedWidth: 64,
  clipped: true,
  headerPosition: 'sticky',
  squeezed: true,
  footerShrink: true,
};

const MainNav = ({children}) => {
  const classes = useStyles();

  return (
    <Root className={classes.root} config={config}>
      <CssBaseline />
      <Header />
      <Content>{children}</Content>
      <Footer />
    </Root>
  );
};

MainNav.propTypes = {
  children: PropTypes.node,
};

export default MainNav;
